import {SCHEME} from '@zzng/common/constants/scheme';
import {openExternalWebview} from '@zzng/common/scheme/web';

import PageLayout from '@/shared/components/PageLayout';
import {TIARA_ACTION, TIARA_PAGE_NAME} from '@/shared/constants/tiara';

type Props = {
  showLoginButton?: boolean;
};

const LoginErrorPage = ({showLoginButton = true}: Props) => {
  const onClickKakaoLogin = () => {
    openExternalWebview(SCHEME.ACCOUNT, {isCurrentWebviewClose: true});
  };

  return (
    <PageLayout
      tiara={{pageName: TIARA_PAGE_NAME.ERROR, pageAction: TIARA_ACTION.INVALID_LOGIN_ERROR}}
      className="container-bridge"
      articleClassName="content-full"
    >
      <div className="inner_g">
        <div className="group_empty type2">
          <strong className="tit_g">
            <span className="item_txt" role="text">
              <span className="txt_tit">카카오계정으로 로그인해 주세요</span>
            </span>
          </strong>
          <p className="txt_g">
            로그인이 진행되지 않을 경우 <br />
            고객센터로 문의해 주세요.
          </p>
          {showLoginButton && (
            <button
              type="button"
              className="btn btn_gray type2"
              data-tiara-action-name={TIARA_ACTION.INVALID_LOGIN_CONFIRM_CLICK}
              onClick={onClickKakaoLogin}
            >
              로그인
            </button>
          )}
        </div>
      </div>
    </PageLayout>
  );
};

export default LoginErrorPage;
